module.exports = __webpack_public_path__ + "static/img/a068.8b47965.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a068.jpg
// module id = b0oa
// module chunks = 0